import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

export interface SendReferralPayload {
  mobile_no: string;
  child_name: string;
  referral_link: string;
  timezone?: string;
}

export interface SendReferralResponse {
  message: string;
  event_id: string;
}

export const sendReferral = (
  payload: SendReferralPayload
): Promise<SendReferralResponse> => {
  return axios.post('/user/referrals/v1/send-referral', payload);
};

export const sendReferralMockHandler = http.post(
  `${env.API_URL}/user/referrals/v1/send-referral`,
  async (): Promise<HttpResponse<SendReferralResponse>> => {
    await networkDelay();
    return HttpResponse.json({
      message: 'Referral submitted successfully.',
      event_id: 'mock-event-id',
    });
  }
);
